/**
 * iter-359g — SHARED project-type / segment taxonomy used by BOTH the
 * "Ask AI Assistant" page (AIBudgetEstimation) and the "AI Task Creator"
 * dialog inside Edit BOQ. Keeping a single source-of-truth here means the
 * two AI entry points always speak the same language and the backend
 * `_SEGMENT_HINTS` map (backend/routers/boq_ai_assist.py) can key off the
 * same identifiers.
 */
import { Building, Building2, Box, Wrench, Briefcase, FolderOpen, Factory } from 'lucide-react';

export const PROJECT_TYPES = [
  { value: 'residential_apartment', label: 'Residential Apartment', short: 'Res. Apartment', description: 'Builder-provided base', icon: Building, group: 'residential' },
  { value: 'residential_villa', label: 'Residential Villa/Bungalow', short: 'Villa', description: 'Full scope', icon: Building2, group: 'residential' },
  { value: 'bare_shell', label: 'Bare Shell Apartment', short: 'Bare Shell', description: 'Complete fit-out', icon: Box, group: 'residential' },
  { value: 'renovation', label: 'Renovation', short: 'Renovation', description: 'Existing property upgrade', icon: Wrench, group: 'residential' },
  { value: 'commercial', label: 'Commercial Office', short: 'Office', description: 'Corporate space', icon: Briefcase, group: 'commercial' },
  { value: 'retail_showroom', label: 'Retail/Showroom', short: 'Retail', description: 'Commercial display', icon: FolderOpen, group: 'commercial' },
  { value: 'industrial', label: 'Industrial', short: 'Industrial', description: 'Factory/Warehouse', icon: Factory, group: 'industrial' },
];

// Convenience — id → row
export const PROJECT_TYPE_MAP = PROJECT_TYPES.reduce((acc, pt) => {
  acc[pt.value] = pt; return acc;
}, {});

// Group value used by the backend spec mapper (residential / commercial / industrial).
export function segmentGroup(projectType) {
  const row = PROJECT_TYPE_MAP[projectType];
  return row ? row.group : 'residential';
}

// Fix 9: map a project's stored project_type (e.g. "Commercial") → AI segment value.
export function segmentFromProjectType(projectType) {
  const raw = String(projectType || '').trim().toLowerCase();
  if (!raw) return 'residential_apartment';
  const exact = PROJECT_TYPES.find(pt => pt.value === raw || pt.label.toLowerCase() === raw);
  if (exact) return exact.value;
  if (raw.includes('retail') || raw.includes('showroom')) return 'retail_showroom';
  if (raw.includes('commercial') || raw.includes('office')) return 'commercial';
  if (raw.includes('industrial') || raw.includes('factory') || raw.includes('warehouse')) return 'industrial';
  if (raw.includes('villa') || raw.includes('bungalow')) return 'residential_villa';
  if (raw.includes('bare')) return 'bare_shell';
  if (raw.includes('renovation')) return 'renovation';
  return 'residential_apartment';
}
